import BreadCrumbs from 'components/Catalog/BreadCrumbs/BreadCrumbs';

export default BreadCrumbs;
